const $w = $(window),
  $b = $("body");

gsap.registerPlugin(ScrollTrigger);

/*****************************************************
 *
 * スマホでのタップ挙動調整
 *
 *****************************************************/

// スマホで触れている間だけhoverする処理
$(function () {
  $("a, label, button")
    .on("touchstart", function () {
      $(this).addClass("is-hover");
    })
    .on("touchend", function () {
      $(this).removeClass("is-hover");
    });
});

// Fast Click
document.addEventListener(
  "DOMContentLoaded",
  function () {
    FastClick.attach(document.body);
  },
  false
);

/*****************************************************
 *
 * メニューとナビゲーション
 *
 *****************************************************/

const $menu = $(".c-drawer"),
  $btn_menu = $(".js-hamburger");
$btn_menu.on("mousedown touchend", function () {
  toggleSpMenu();
});
function toggleSpMenu() {
  $btn_menu.toggleClass("is-active");
  $menu.toggleClass("is-active");
}

/*****************************************************
 *
 * するするスクロール
 *
 *****************************************************/

//するするスクロール
(function setAnchorClickEvent() {
  //通常のクリック時
  $('a[href^="#"]').click(function () {
    //ページ内リンク先を取得
    var href = $(this).attr("href"); //リンク先が#か空だったらhtmlに

    var hash = href == "#" || href == "" ? "html" : href; //スクロール実行

    scrollToAnker(hash); //リンク無効化

    return false;
  });
})();

function scrollToAnker(hash) {
  var headerHeight = 0; //ヘッダーは0px.

  var target = $(hash);

  if (target[0]) {
    var position = target.offset().top - headerHeight;
    $("body,html").stop().animate(
      {
        scrollTop: position,
      },
      500
    );
  } else {
    console.log("hash" + hash + "が見つかりません");
  }
} // a要素のクリック時にセット

/*****************************************************
 *
 * KVスライダー
 *
 *****************************************************/

const kvSlide = new Swiper(".top-kv-slider", {
  allowTouchMove: false,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  direction: "horizontal",
  effect: "fade",
  loop: true,
  speed: 600,
  touchMoveStopPropagation: false,
});

/*****************************************************
 *
 * ページ読み込み時のtransitionによるアニメーションをキャンセル
 *
 *****************************************************/

/* 読み込み時のtransitionによるアニメーションをキャンセル */
setTimeout(transitionCancel, 100);
function transitionCancel() {
  document.body.classList.remove("c-preload");
}

/*****************************************************
 *
 * aboutページスライダー
 *
 *****************************************************/

const aboutSlide = new Swiper(".about-collection__slider", {
  allowTouchMove: false,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  direction: "horizontal",
  loop: true,
  slidesPerView: "auto",
  spaceBetween: 35,
  speed: 1600,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

/*****************************************************
 *
 * aboutページパララックス
 *
 *****************************************************/

const parallaxes = document.querySelectorAll(".js-parallax img");

parallaxes.forEach((parallax) => {
  gsap.to(parallax, {
    yPercent: -20,
    ease: "linear",
    scrollTrigger: {
      trigger: parallax,
      scrub: true,
      start: "top bottom",
      end: "bottom top",
      // markers: true
    },
  });
});

/*****************************************************
 *
 * aboutページパララックス
 *
 *****************************************************/

const triggers = document.querySelectorAll(".js-trigger");

ScrollTrigger.create({
  trigger: ".js-trigger",
  start: "top top",
  end: "bottom top",
  scrub: true,
  pin: true,
  // markers: true
});

/*****************************************************
 *
 * faqページ
 * 目次にhref付与/dtにID付与/liが4つ以上でbuttonを生成
 *
 *****************************************************/

//dtにID付与
// const lists = document.querySelectorAll('.faq-details__list');

// for (let i=0; i<lists.length; i++) {
//     const dts = lists[i].querySelectorAll('dt');

//     for (let j = 0; j < dts.length; j++) {
//         let link_id = ('00' + (i+1)).slice(1) + '-' + ('00' + (j+1)).slice(1);
//         dts[j].id = link_id;
//     }
// }
document.addEventListener("DOMContentLoaded", () => {
  const faqHeadlines = document.querySelectorAll(
    ".faq-details .faq-details__headline"
  );

  faqHeadlines.forEach((headline, index) => {
    // 頭2桁を01から開始、後半も01から開始
    const mainNumber = String(Math.floor(index / 10) + 1).padStart(2, "0");
    const subNumber = String((index % 10) + 1).padStart(2, "0");
    headline.id = `${mainNumber}-${subNumber}`;
  });
});

//目次にhref付与、listにクラス付与、button生成
const contents_lists = document.querySelectorAll(".faq-contents__items-list");

for (let i = 0; i < contents_lists.length; i++) {
  //listにjs-list00クラス付与
  contents_lists[i].classList.add("js-list" + ("00" + (i + 1)).slice(1));

  //目次にhref付与
  const lis = contents_lists[i].querySelectorAll("li a");
  for (let j = 0; j < lis.length; j++) {
    let link =
      "#" + ("00" + (i + 1)).slice(1) + "-" + ("00" + (j + 1)).slice(1);
    lis[j].href = link;
  }

  //liが4つ以上存在したらbuttonを生成・data属性付与
  if (contents_lists[i].children.length > 3) {
    const button = document.createElement("button");
    button.className = "faq-contents__items-button js-expand";
    button.dataset.target = "js-list" + ("00" + (i + 1)).slice(1);
    button.textContent = "質問をすべて見る";

    const button_wrapper = document.createElement("div");
    button_wrapper.className = "faq-contents__items-button-wrapper";
    button_wrapper.appendChild(button);
    contents_lists[i].parentElement.appendChild(button_wrapper);
  }
}

/*****************************************************
 *
 *
 * faqページ、button.js-expandに指定したdata-target（クラス名）に該当する要素を開閉する。
 *
 *
 *****************************************************/

$(".js-expand").on("click", expandContent);
function expandContent(e) {
  //リストにis-activeクラス付与
  let target_class_name = $(e.target).attr("data-target");
  $(e.target).toggleClass("is-active");
  $("." + target_class_name).toggleClass("is-active");

  //ボタンのテキストを変更
  if ($("." + target_class_name).hasClass("is-active")) {
    $(e.target).text("閉じる");
  } else {
    $(e.target).text("質問をすべて見る");
  }
}

/*****************************************************
 *
 * テキスト、画像アニメーション
 *
 *****************************************************/

const a_fadeup = gsap.utils.toArray(".a-fadeup");
a_fadeup.forEach((a_fadeup) => {
  ScrollTrigger.create({
    start: "center bottom",
    onEnter: () => a_fadeup.classList.add("is-animated"),
    onLeaveBack: () => a_fadeup.classList.add("is-animated"),
    trigger: a_fadeup,
    once: true,
    // markers: true,
  });
});

const a_blur = gsap.utils.toArray(".a-blur");
a_blur.forEach((a_blur) => {
  ScrollTrigger.create({
    start: "center bottom",
    onEnter: () => a_blur.classList.add("is-animated"),
    onLeaveBack: () => a_blur.classList.add("is-animated"),
    trigger: a_blur,
    once: true,
    // markers: true,
  });
});

//色の反転
const invert = gsap.utils.toArray(".js-invert");
invert.forEach((invert) => {
  ScrollTrigger.create({
    start: "top top",
    onEnter: () => invert.classList.add("is-animated"),
    onLeaveBack: () => invert.classList.remove("is-animated"),
    trigger: invert,
    // markers: true,
  });
});

/*****************************************************
 *
 * サイドバーの表示切り替え（スクロールダウン・SNSアイコン）
 *
 *****************************************************/

const scroll_down = document.querySelector(".c-sidebar__scroll");
const sidebar_sns = document.querySelector(".c-sidebar__sns");

if (scroll_down) {
  ScrollTrigger.create({
    trigger: "#start",
    start: "top top",
    onEnter: () => scroll_down.classList.add("is-hide"),
    onEnterBack: () => scroll_down.classList.remove("is-hide"),
    //    markers: true
  });

  ScrollTrigger.create({
    trigger: "#start",
    start: "top top",
    onEnter: () => sidebar_sns.classList.add("is-show"),
    onEnterBack: () => sidebar_sns.classList.remove("is-show"),
    //    markers: true
  });
}

/*****************************************************
 *
 * フォームのバリデーション
 *
 *****************************************************/

// const submit_btn = document.querySelector('.field__submit-button');
// const requires = document.querySelectorAll('[aria-required="true"]')

// if (submit_btn) {
//     //送信ボタンをクリックしたらエラメッセージを表示
//     submit_btn.addEventListener('click', (e) => {
//         displayErrorMessage(e);
//     })
//     submit_btn.addEventListener('touchstart', (e) => {
//         displayErrorMessage(e);
//     })

//     //input要素に入力したらエラーメッセージ&is-errorクラスを削除
//     requires.forEach(require => {
//         require.addEventListener('change', () => {
//             require.classList.remove('is-error');
//             // require.nextElementSibling.remove();
//         })
//     })

//     //同意確認ができたら、送信ボタンが有効になる
//     const privacy_check = document.querySelector('.field__checkbox .field__label');

//     privacy_check.addEventListener('click', () => {
//         toggleClass(submit_btn, 'is-disabled');
//     })
//     privacy_check.addEventListener('touchstart', () => {
//         toggleClass(submit_btn, 'is-disabled');
//     })
// }

// function displayErrorMessage(e) {
//     //ボタンのデフォルトアクションをキャンセル
//     e.preventDefault();

//     //エラーメッセージリセット
//     const error_messages = document.querySelectorAll('.field__error');
//     error_messages.forEach(message => {
//         message.remove();
//     })

//     //aria-requiredがtrueになっているinputタグをループ処理
//     requires.forEach(require => {

//         //エラーメッセージ用にname属性を取得
//         let name = require.getAttribute('name');

//         if (require.value == '') {
//             //エラーメッセージ用のspanを生成する
//             let element = document.createElement('span');
//             element.classList.add('field__error');
//             element.textContent = `${name}を入力してください。`;

//             //エラーメッセージ用のspanを挿入する
//             require.parentNode.appendChild(element);

//             //inputタグにis-errorクラス付与
//             require.classList.add('is-error');
//         }
//     })

// }

// function toggleClass(target, classname) {
//     target.classList.toggle(classname);
// }

/*****************************************************
 *
 * 一覧ページの該当カテゴリーにis-activeクラスを付与
 *
 *****************************************************/

const news_categories = document.querySelectorAll(
  ".news-list__archives-list li a"
);
const recipe_categories = document.querySelectorAll(
  ".recipe-list__archives-list li a"
);

news_categories.forEach((category) => {
  activateCategory(category);
});
recipe_categories.forEach((category) => {
  activateCategory(category);
});

function activateCategory(target) {
  if (target.href === window.location.href) {
    target.parentNode.classList.add("is-active");
  }
}

/*****************************************************
 *
 * レビューでページのトップへの移動を防ぐ
 *
 *****************************************************/
$(document).ready(function() {
  function initializeSlider(containerSelector, listSelector, prevButtonSelector, nextButtonSelector, currentSelector, totalSelector) {
    const $slider = $(containerSelector).find(listSelector);
    const $items = $slider.find('.list-item');
    const $prev = $(containerSelector).find(prevButtonSelector);
    const $next = $(containerSelector).find(nextButtonSelector);
    const $current = $(containerSelector).find(currentSelector);
    const $total = $(containerSelector).find(totalSelector);
    const totalSlides = $items.length;
    let currentIndex = 0;

    // 合計の数を動的に設定
    $total.text(totalSlides);

    function moveSlide() {
      const translateX = -currentIndex * 100;
      $slider.css({
        'transform': `translateX(${translateX}%)`,
        'transition': 'transform 0.3s ease'
      });
      $current.text(currentIndex + 1);
      updateButtons();
    }

    function updateButtons() {
      $prev.prop('disabled', currentIndex === 0);
      $next.prop('disabled', currentIndex === totalSlides - 1);
    }

    $next.on('click', function() {
      if (currentIndex < totalSlides - 1) {
        currentIndex++;
        moveSlide();
      }
    });

    $prev.on('click', function() {
      if (currentIndex > 0) {
        currentIndex--;
        moveSlide();
      }
    });

    updateButtons();
  }

  // 既存のスライダー
  initializeSlider('.features-slider-container.donabe', '.list.donabe', '.prev-button.donabe', '.next-button.donabe', '.pagination .current.donabe', '.pagination .total.donabe');

  // 新しいレシピセクションのスライダー
  initializeSlider('.collection-cook-recipe', '.recipe-list', '.prev-button.recipe', '.next-button.recipe', '.pagination .current.recipe', '.pagination .total.recipe');
});



/*****************************************************
 *
 * モーダル
 *
 *****************************************************/

$(".js-modal-open").on("click", function() {
  const modal = $(this).data("modal-open");
  $("[data-modal=" + modal + "]").addClass("is-active");
});

$(".js-modal-close").on("click", function() {
  const modal = $(this).data("modal-close");
  $("[data-modal=" + modal + "]").removeClass("is-active");
});



/*****************************************************
 *
 * 関連商品スライダー
 *
 *****************************************************/

const relatedItemsSlide = new Swiper(".js-related-items-slider", {
  allowTouchMove: true,
  effect: "slide",
  loop: true,
  speed: 600,
  slidesPerView: 2,
  pagination: {
    el: '.p-daikoku-related-items__pagination',
    clickable: true,
  },
  breakpoints: {
    960: {
      slidesPerView: 4,
    },
    640: {
      slidesPerView: 3,
    },
  },
});

/*****************************************************
 *
 * タブUI
 *
 *****************************************************/

$(".js-tab-button").on("click", function() {
  const targetTab = $(this).data("tab");
  
  // ボタンのアクティブ状態を切り替え
  $(".js-tab-button").removeClass("is-active");
  $(this).addClass("is-active");
  
  // コンテンツの表示を切り替え
  $(".js-tab-content").removeClass("is-active");
  $('[data-tab="' + targetTab + '"]').addClass("is-active");
});
